<template>
  <div class="hotel-edit-accordion-3">
    <div class="form--row">
      <div>
        <div class="reference-tour" id="form--hour-checkin">
          <!-- INTEGRAÇÃO -->
          <PmwHeading
            size="paragraph-80"
            weight="weight-light"
            class="form--title"
            >Horários de check-in e check-out
          </PmwHeading>

          <div class="form--row form--row__min-spacing mb-0">
            <!-- CHECKIN -->
            <PmwFormInput
              :value="checkin"
              :required="true"
              :error="errors.includes('horaCheckin')"
              data-error="horaCheckin"
              step="3600"
              type="time"
              label="Check-in"
              placeholder=""
              class="form--input__time"
              @input="$emit('changeCheckin', $event)"
            />

            <!-- CHECKOUT -->
            <PmwFormInput
              :value="checkout"
              :required="true"
              :error="errors.includes('horaCheckout')"
              data-error="horaCheckout"
              step="3600"
              type="time"
              label="Check-out"
              placeholder=""
              class="form--input__time"
              @input="$emit('changeCheckout', $event)"
            />
          </div>
        </div>
      </div>
      <div class="flex-grow-1">
        <!-- INTEGRAÇÃO -->
        <PmwHeading
          size="paragraph-80"
          weight="weight-light"
          class="form--title"
          >Integração com Tripadvisor
        </PmwHeading>

        <div class="form--row form--row__min-spacing mb-0">
          <!-- CÓDIGO TRIP ADVISOR -->
          <PmwFormInput
            :value="tripAdvisor"
            :infoIcon="true"
            tooltipMinWidth="226"
            infoText="Código do hotel no Tripadvisor. Este habilita a exibição da avaliação do hotel no Tripadvisor e mostra os últimos comentários."
            label="Código de integração"
            placeholder="Insira o código"
            class="form--input"
            id="form--trip-advisor"
            @input="$emit('changeTripAdvisor', $event)"
          />

          <InputCheckbox
            :value="exibeTripAdvisor"
            :checked="exibeTripAdvisor"
            :inputValue="true"
            label="Exibe modal na área pública?"
            name="exibeTripAdvisor"
            @input="$emit('changeExibeTripAdvisor', $event)"
          />
        </div>
      </div>
    </div>
    <div class="form--row mb-0">
      <div>
        <!-- REGIÃO -->
        <PmwHeading
          size="paragraph-80"
          weight="weight-light"
          class="form--title"
          >Moedas aceitas</PmwHeading
        >

        <!-- MOEDA -->
        <PmwFormSelect
          :value="coin"
          :options="coins"
          :search="true"
          :required="true"
          label="Selecione a moeda"
          placeholder="Ex: Real, Dólar, Euro."
          class="form--input form--input__coin"
          id="form--coin"
          @input="$emit('changeCoin', $event)"
        />
      </div>

      <div class="flex-grow-1">
        <!-- CATEGORIA -->
        <PmwHeading
          size="paragraph-80"
          weight="weight-light"
          class="form--title"
          >Categoria para relatórios
        </PmwHeading>

        <div class="form--row form--row__min-spacing mb-0">
          <!-- CATEGORIA -->
          <PmwFormSelect
            :value="category"
            :options="categories"
            :search="true"
            :required="true"
            label="Categoria"
            placeholder="Ex: Lazer, Corporativo."
            class="form--input form--input__select"
            id="form--category"
            @input="$emit('changeCategory', $event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'

export default {
  name: 'PaymentSettingsAndSchedules',
  components: {
    PmwHeading,
    PmwFormInput,
    PmwFormSelect,
    InputCheckbox
  },
  props: {
    checkin: {
      type: [String, Number],
      default: null
    },

    checkout: {
      type: [String, Number],
      default: null
    },

    tripAdvisor: {
      type: [String, Number],
      default: null
    },

    exibeTripAdvisor: {
      type: Boolean,
      default: true
    },

    coin: {
      type: Object,
      default: () => {}
    },

    /** Categoria de hotel */
    category: {
      type: Object,
      default: () => {}
    },

    email: {
      type: String,
      default: null
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    },

    /** Listagem de moedas */
    coins: {
      type: Array,
      default: () => []
    },

    /** Listagem de categorias de hotéis */
    categories: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.reference-tour {
  position: relative;
}

.pmw-form-field {
  ::v-deep {
    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }
    .form-field--label-wrapper {
      line-height: 21px;
      margin-bottom: 3px;
    }
    .pmw-input {
      background: $white;
    }
    .pmw-input--clear {
      z-index: 0;
    }
    .pmw-input__focus {
      border-color: $pmw-blue;
    }

    .pmw-input--field {
      background: $pmw-white;

      &:focus {
        border-color: $pmw-blue;
      }
    }

    .pmw-custom-tooltip {
      line-height: 18px;
    }
  }
}

.form {
  &--input {
    max-width: 176px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }

      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__time {
      max-width: 98px;
    }

    &__coin {
      width: 235px;
      max-width: 235px;
    }

    &__select {
      width: 100%;
      max-width: 248px;

      &.error {
        ::v-deep {
          .pmw-select--button {
            border-bottom-color: pmw-colors('error-100');
            border-bottom-width: 2px;
          }
        }
      }
    }
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 108px;
    margin-bottom: 42px;

    &__min-spacing {
      flex-wrap: nowrap;
      gap: 22px;
    }
  }

  &--title {
    color: pmw-colors('blue-100');
    font-weight: font-weight('weight-medium');
    margin-bottom: 24px;
    position: relative;
  }
}

.pmw-input-checkbox ::v-deep {
  span {
    overflow: initial;
  }
}
</style>
